module.exports = __webpack_public_path__ + "img/Riesenrad.e6e85d6c.svg";